module.exports = "pegasus/assets/blocks/column-lp14-basic.png";